import { RootState } from '../reducers';

export const getAlertItems = (state: RootState): RootState['alerts'] => {
  return state.alerts;
};
